<vl-multiselect
    v-model="selectedOrganisationId"
    :options="organisationOptions"
    :mode="mode"
    :searchable="true"
    label="title"
    placeholder="Zoek een organisatie"
    :loading="organisationOptionsFetching"
    @search-change="onOrganisationInputChange"
    noResultsText="Geen resultaten gevonden..."
    noOptionsText="Geen opties beschikbaar!"
>
    <template v-slot:option="{ option }">
        <div class="kl-search-organisation__option">
            <div>
                {{ option.title }}
            </div>
            <vl-annotation v-if="option.subtitle" class="kl-search-organisation__option__subtitle">
                {{ option.subtitle }}
            </vl-annotation>
        </div>
    </template>
</vl-multiselect>
